var exports = {
  "x": "ShowMore__bqyJ_3",
};

module.exports = exports;
